import { z } from "zod";

import { constantsData } from "@/data";

export const profileFormSchema = z.object({
    email: z.string().min(
        1,
        { message: constantsData.msgs.requiredField },
    ).email(constantsData.msgs.notValidEmail),
    firstName: z.string().min(
        1,
        { message: constantsData.msgs.requiredField },
    ),
    lastName: z.string().min(
        1,
        { message: constantsData.msgs.requiredField },
    ),
    username: z.string().min(
        1,
        { message: constantsData.msgs.requiredField },
    ),
});
